export default {
  meta: {
    title: '客流详情'
  }
};
